import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Real } from '../../../core/models/real.model';
import { ProviderService } from '../../../core/models/provider-service.model';
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription } from 'rxjs';
import { ProviderServiceService } from '../../../core/services/provider-service.service';
import { polyfill } from "seamless-scroll-polyfill";
polyfill();

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  @Input() real: Real;
  @Input() anchor$: Observable<string>;

  @ViewChild("popularDishes") popularDishesEl: ElementRef;
  @ViewChild("aLaCarte") aLaCarteEl: ElementRef;
  @ViewChild("wineList") wineListEl: ElementRef;

  servicesSubscription: Subscription;
  anchorSubscription: Subscription;

  categories: ProviderService[];
  popularDishesCategory: ProviderService;
  menus: ProviderService[] = [];

  constructor( public translateService: TranslateService, private providerServiceService: ProviderServiceService ) { }

  ngOnDestroy() {
    this.servicesSubscription.unsubscribe();
    this.anchorSubscription.unsubscribe();
  }

  ngOnInit() {

    this.anchorSubscription = this.anchor$.subscribe( anchor => this.scrollTo( anchor ) );

    this.servicesSubscription = this.providerServiceService.getServicesForPicking( this.real.selectionItems[0].id ).subscribe(

      result => {

        this.categories = result;

        for (let category of this.categories ) {

          if ( category.slug.substr(0, 12) === 'priljubljene') {
            this.popularDishesCategory = category;
          }

          if ( category.slug.substr(0, 12) !== 'priljubljene' && !category.event ) {
            this.menus.push( category );
          }

        }

      }

    );

  }

  scrollTo( anchorName ) {


    let el: ElementRef;

    switch ( anchorName ) {
      case 'popularDishes':
        el = this.popularDishesEl;
        break;
      case 'wineList':
        console.log('sdgsdg');
        el = this.wineListEl;
        break;
      case 'aLaCarte':
        el = this.aLaCarteEl;
        break;
      default:
        el = this.popularDishesEl;
        break;
    } 

    el.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });

  }

}
